import { render, staticRenderFns } from "./ScoreBar.vue?vue&type=template&id=845ac210&scoped=true"
import script from "./ScoreBar.vue?vue&type=script&lang=js"
export * from "./ScoreBar.vue?vue&type=script&lang=js"
import style0 from "./ScoreBar.vue?vue&type=style&index=0&id=845ac210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845ac210",
  null
  
)

export default component.exports